<template>
  <form ref="form" action="#" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <div class="l-page l-page--message-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <div v-if="!messageId" class="c-title__text c-title__text--blue u-fs34">配信メッセージの新規作成</div>
            <div v-else class="c-title__text c-title__text--blue u-fs34">配信メッセージの編集</div>
          </div>
          <div class="c-progress">
            <ul class="c-progress-list">
              <li class="c-progress-list__item is-current">メッセージの作成</li>
              <li class="c-progress-list__item">配信内容の確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit p-message-edit--message-group">
            <div class="c-title c-title--left">
              <div class="c-title__text u-fs24">メッセージのグループ管理名を登録する</div>
              <div class="c-text u-fs--s">配信するメッセージをグループとして管理していきます</div>
            </div>
            <div class="p-message-edit-list p-message-edit-list--first">
              <div class="p-message-edit-list__item">
                <div class="c-input u-w50p">
                  <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span>プッシュ名を設定する</div>
                  <input
                    v-model="messageName"
                    class="c-input__item"
                    type="text"
                    name="push_name"
                    value=""
                    placeholder="プッシュ名を入力してください"
                    maxlength="300"
                  />
                  <div class="c-error c-error--balloon">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list__item">
                <div class="c-input u-w50p">
                  <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span></div>
                </div>
                <div class="c-radio u-w100p">
                  <ul class="c-radio-list">
                    <li class="c-radio-list__item u-w50p">
                      <label class="c-radio__label">
                        <input
                          v-model="groupType"
                          type="radio"
                          name="message_group"
                          value="1"
                        />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">すでにあるグループを設定する</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item u-w50p">
                      <label class="c-radio__label">
                        <input
                          v-model="groupType"
                          type="radio"
                          name="message_group"
                          value="2"
                        />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">新しくグループを設定する</div>
                        </div>
                      </label>
                    </li>
                  </ul>
                  <div class="c-error">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list__item">
                <select-text
                  ref="groupSelect"
                  input-name="group_name_select"
                  place-holder="グループ名を選択してください"
                  :classes="['u-w450']"
                  :elements="messageInfo.messageGroups"
                  @select="onGroupSelect"
                />
                <!--
                               <div class="c-select u-w450">
                                <div class="c-select__selected is-empty">
                                    グループ名を選択してください
                                </div>
                                <div class="c-select-options">
                                    <div class="c-select-options__item" data-value="1">メッセージグループ1</div>
                                    <div class="c-select-options__item" data-value="2">メッセージグループ2</div>
                                    <div class="c-select-options__item" data-value="3">メッセージグループ3</div>
                                </div>
                                <input type="hidden" name="message_group_id" value="">
                                <div class="c-error c-error--balloon c-error--group-name">
                                    <div class="c-error__text"></div>
                                </div>
                            </div>
                            -->
                <div class="c-input u-w466">
                  <input
                    v-model="newGroupName"
                    class="c-input__item"
                    type="text"
                    name="message_group_name"
                    value=""
                    placeholder="新しいグループ名を入力してください"
                    maxlength="300"
                  />
                  <div class="c-error c-error--balloon c-error--group-name">
                    <div class="c-error__text"></div>
                  </div>
                </div>
                <div class="c-text c-text--desc">
                  ※グループとは、配信メッセージをグループでまとめることが出来ます。グループ毎に配信結果を確認するなど分析時ご利用頂けます。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-content l-main-content--half l-main-content--left">
          <!-- 配信メッセージ設定 -->
          <message-cart-form ref="messageCartForm" v-model="message" />
        </div>
        <div class="l-main-content l-main-content--half l-main-content--right">
          <div class="p-message-preview">
            <div class="c-title c-title--left u-text-white-1">
              <div class="c-title__text u-fs--l ">プレビュー</div>
              <div class="c-text u-fs10">実際の配信メッセージと表示が異なることがあります</div>
            </div>

            <ul class="c-tab-list">
              <li
                class="c-tab-list__item"
                :class="{'is-active': previewType == 'desktop' }"
                data-type="desktop"
                @click="chengePreviewType('desktop')"
              >PCでの配信例</li>
              <li
                class="c-tab-list__item"
                :class="{'is-active': previewType == 'mobile' }"
                data-type="mobile"
                @click="chengePreviewType('mobile')"
              >スマホでの配信例</li>
            </ul>

            <div v-show="previewType == 'desktop'" class="p-message-preview-list">
              <div class="p-message-edit-list__item">
                <div class="c-input">
                  <div class="c-input__title">1回目に配信するメッセージ</div>
                  <message-preview
                    :title="message.cartTitleFirst"
                    :text="message.cartMessageFirst"
                    :url="message.clickUrl"
                    :icon-url="previewIconUrl"
                    :large-image-url="message.largeImageUrl"
                  />
                </div>
              </div>
              <div v-if="message.cartTitleSecond" class="p-message-edit-list__item">
                <div class="c-input">
                  <div class="c-input__title">2回目に配信するメッセージ</div>
                  <message-preview
                    :title="message.cartTitleSecond"
                    :text="message.cartMessageSecond"
                    :url="message.clickUrl"
                    :icon-url="previewIconUrl"
                    :large-image-url="message.largeImageUrl"
                  />
                </div>
              </div>
              <div v-if="message.cartTitleThird" class="p-message-edit-list__item">
                <div class="c-input">
                  <div class="c-input__title">3回目に配信するメッセージ</div>
                  <message-preview
                    :title="message.cartTitleThird"
                    :text="message.cartMessageThird"
                    :url="message.clickUrl"
                    :icon-url="previewIconUrl"
                    :large-image-url="message.largeImageUrl"
                  />
                </div>
              </div>
            </div>

            <div v-show="previewType == 'mobile'" class="p-message-preview-list">
              <div class="p-message-edit-list__item">
                <div class="c-input">
                  <div class="c-input__title">1回目に配信するメッセージ</div>
                  <message-preview-sp
                    :title="message.cartTitleFirst"
                    :text="message.cartMessageFirst"
                    :url="message.clickUrl"
                    :icon-url="previewIconUrl"
                    :large-image-url="message.largeImageUrl"
                  />
                </div>
              </div>
              <div v-if="message.cartTitleSecond" class="p-message-edit-list__item">
                <div class="c-input">
                  <div class="c-input__title">2回目に配信するメッセージ</div>
                  <message-preview-sp
                    :title="message.cartTitleSecond"
                    :text="message.cartMessageSecond"
                    :url="message.clickUrl"
                    :icon-url="previewIconUrl"
                    :large-image-url="message.largeImageUrl"
                    :badge-url="previewBadgeUrl"
                  />
                </div>
              </div>
              <div v-if="message.cartTitleThird" class="p-message-edit-list__item">
                <div class="c-input">
                  <div class="c-input__title">3回目に配信するメッセージ</div>
                  <message-preview-sp
                    :title="message.cartTitleThird"
                    :text="message.cartMessageThird"
                    :url="message.clickUrl"
                    :icon-url="previewIconUrl"
                    :large-image-url="message.largeImageUrl"
                    :badge-url="previewBadgeUrl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onQuitClick"
            >
              <p v-if="!messageId" class="c-btn__text">作成をやめる</p>
              <p v-else class="c-btn__text">編集をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              :class="{ 'is-loading': isLoadingSaveBtn }"
              :disabled="isLoadingSaveBtn"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div class="p-message-predict__btns">
          <button
            v-tooltip="existsActiveCartMessage && 'すでに配信中のカートプッシュが存在しています'"
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{
              'is-loading': isLoadingConfirmBtn,
              'is-completed': existsActiveCartMessage,
            }"
            :disabled="isLoadingConfirmBtn || existsActiveCartMessage"
            type="button"
            name="confirm"
            value="confirm"
            @click="onConfirmClick()"
          >
            <p class="c-btn__text">内容の確認画面へ</p>
          </button>
          <button
            v-if="messageInfo.message?.deliver_status == 30"
            class="c-btn c-btn--red u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingStopBtn }"
            :disabled="isLoadingStopBtn"
            type="button"
            name="next"
            value="next"
            @click="onStopClick()"
          >
            <p class="c-btn__text">配信を停止する</p>
          </button>
        </div>
      </div>
    </div>

    <!-- モーダル: 確認画面へボタンクリック -->
    <control-modal
      ref="refConfirmationButtonModal"
      classes="c-modal--message-delete"
      title="確認メッセージ"
      :body="`現在配信中のカートプッシュに反映されます。メッセージを更新しますか？`"
      cancel-button-label="キャンセル"
      enter-button-label="OK"
      :is-active=confirmationButtonFlg
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModalForConfirmButtton"
    />

    <!-- モーダル: 保存するボタンクリック -->
    <control-modal
      ref="refSavedButtonModal"
      classes="c-modal--message-delete"
      title="確認メッセージ"
      :body="`現在配信中のカートプッシュに反映されます。メッセージを更新しますか？`"
      cancel-button-label="キャンセル"
      enter-button-label="OK"
      :is-active=savedMessageButtonFlg
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModalForSavedButtton"
    />

    <!-- モーダル: 配信設定・配信停止完了メッセージ表示 -->
    <control-modal
      ref="refCompleteModal"
      classes="c-modal--result"
      :body="completeMessage"
      cancel-button-label="メッセージ一覧へ"
      :is-active=isCompleteMessage
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCancelControlModal"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </form>
</template>

<script>
import axios from 'axios';
import 'moment';

export default {
  props: {
    messageInfo: Object,
    csrfToken: String,
    addConditionUrl: String,
    addConditionConfirmUrl: String,
    breadcrumbData: Array,
  },
  data () {
    return {
      completeMessage: '',
      errorMessage: '',
      isCompleteMessage: false,
      isError: false,
      isLoadingConfirmBtn: false,
      isLoadingSaveBtn: false,
      isLoadingStopBtn: false,
      existsActiveCartMessage: false,
      message: {
        clickUrl: null,
        iconUrl: null,

        largeImageUrl: null,
        selectedLargeImageFile: null,
        badgeUrl: null,
        selectedBadgeFile: null,
        cartNonWorkingStartHours: null,
        cartNonWorkingEndHours: null,
        utmQuery: null,
        cartWorkHoursFirst: null,
        cartTitleFirst: null,
        cartMessageFirst: null,
        cartWorkHoursSecond: null,
        cartTitleSecond: null,
        cartMessageSecond: null,
        cartWorkHoursThird: null,
        cartTitleThird: null,
        cartMessageThird: null,
        selectedIconFile: null,
      },
      deliverStatus:null,
      messageId: null,
      messageName: null,
      groupId: null,
      groupType: null,
      newGroupName: null,
      currentButton: null,
      serviceType: null,
      previewType: 'desktop',

      // フラグ系
      confirmationButtonFlg: false,
      savedMessageButtonFlg: false
    }
  },
  computed: {
    previewIconUrl: function () {
      return this.message.iconUrl || this.messageInfo.defaultIconUrl;
    },

    previewBadgeUrl: function () {
      return this.message.badgeUrl || this.messageInfo.defaultBadgeUrl;
    }
  },
  created: function () {
    if (this.messageInfo.message?.deliver_status == 30) return;
    axios.get('/api/message/exists-active-cart-message').then((res) => {
      this.existsActiveCartMessage = res.data.exists;
    });
  },
  mounted: function() {
    // ページオープン時のローカルストレージにグループが存在している場合
    const key = 'default_group_' + this.messageInfo.serviceId + '_' + this.messageInfo.serviceType;
    const groupID = localStorage.getItem(key);
    if(groupID){
      this.groupType = 1;
      this.groupId = groupID;
      this.$refs.groupSelect.setValue(groupID);
    }

    import('../../funcs/pages/message-add').then(module => {
      module.MessageAdd();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });

    if(this.messageInfo.message){
      let message = this.messageInfo.message;

      this.serviceType = message.service_type;

      if(this.messageInfo.type == 'edit'){
        this.messageId = message.message_id;
      }
      this.messageName = message.message_name;

      this.message.clickUrl = message.click_url;
      this.message.cartNonWorkingStartHours = message.cart_non_working_start_hours;
      this.message.cartNonWorkingEndHours = message.cart_non_working_end_hours;

      this.message.utmQuery = message.utm_query;

      this.message.cartWorkHoursFirst = message.cart_work_hours_first;
      this.message.cartTitleFirst = message.cart_title_first;
      this.message.cartMessageFirst = message.cart_message_first;

      this.message.cartWorkHoursSecond = message.cart_work_hours_second;
      this.message.cartTitleSecond = message.cart_title_second;
      this.message.cartMessageSecond = message.cart_message_second;

      this.message.cartWorkHoursThird = message.cart_work_hours_third;
      this.message.cartTitleThird = message.cart_title_third;
      this.message.cartMessageThird = message.cart_message_third;

      this.deliverStatus = message.deliver_status;
      if(message.message_group_message != null){
        this.groupType = 1;

        // group_idでマッチするが、実際に子コンポーネントにわたす値は「連番_groupe_id」をわたす
        let keyword;
        for(let key in this.messageInfo.messageGroups){
          keyword = key.split("_")[1];
          if(message.message_group_message.group_id == keyword) {
            this.groupId = message.message_group_message.group_id;
            this.$refs.groupSelect.setValue(key);
            break;
          }
        }
      } else {
        this.groupType = 2;
      }

      if(message.image_url){
        this.message.iconUrl = message.image_url;
      }

      if(message.large_image_url) {
        this.message.largeImageUrl = message.large_image_url;
      }

      if(message.badge_url){
        this.message.badgeUrl = message.badge_url;
      }
    } else {
      this.serviceType = this.messageInfo.serviceType;
    }
  },
  methods: {
    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 確認画面へボタンのモーダルオープン
    onConfirmationMessage: function(_message) {
      this.confirmationButtonFlg = true;
    },
    // クリック: 保存ボタンモーダルオープン
    onSavedMessage: function(_message) {
      this.savedMessageButtonFlg = true;
    },
    // クリック: 確認メッセージのモーダルOKボタンクリック時
    onEnterConrolModalForConfirmButtton() {
      this.saveMessage(this.messageInfo.addConditionConfirmUrl,true);
      this.onCloseConrolModal();
    },
    // クリック: 保存ボタンのモーダルOKボタンクリック時
    onEnterConrolModalForSavedButtton() {
      this.saveMessage(this.messageInfo.listUrl,false);
      this.onCloseConrolModal();
    },
    // クリック: 確認メッセージのモーダルを閉じる処理
    onCloseConrolModal() {
      this.updateLocalStorage();

      this.confirmationButtonFlg = false;
      this.savedMessageButtonFlg = false;

      this.isLoadingConfirmBtn = false;
      this.isLoadingSaveBtn = false;
      this.isLoadingStopBtn = false;
    },
    // クリック: 確認画面へ
    onConfirmClick: function() {
      if(this.validate()){
        this.isLoadingConfirmBtn = true;

        // 配信ステータス：配信済
        const delivered = '30';
        if(this.deliverStatus === delivered){
          this.onConfirmationMessage();
        } else {
          this.updateLocalStorage();
          this.saveMessage(this.messageInfo.addConditionConfirmUrl,true);
        }
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
      }
    },

    // クリック: 作成キャンセル
    onQuitClick: function() {
      location.href = this.messageInfo.listUrl;
    },

    chengePreviewType: function(type) {
      this.previewType = type;
    },

    // クリック: 作成内容の途中保存
    onSaveClick: function() {
      if(this.validate()){
        this.isLoadingSaveBtn = true;

        // 配信ステータス：配信済
        const delivered = '30';
        if(this.deliverStatus === delivered){
          this.onSavedMessage();
        } else {
          this.updateLocalStorage();
          this.saveMessage(this.messageInfo.listUrl,false);
        }
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
      }
    },

    // クリック: 配信中メッセージの停止
    onStopClick: function() {
      // ローディング表示設定, ボタン無効化設定
      this.isLoadingStopBtn = true;

      // 設定用パラメタ作成
      const params = {
        message_id: this.messageId,
      };

      axios.post('/api/message/stop',params)
        .then(res => {
          if(this.handleResponse(res)){
            this.completeMessage = 'プッシュ通知の配信停止が完了しました。';
            this.isCompleteMessage = true;
          } else {
            this.isError = true;
            this.errorMessage = (res && res.data && res.data.message)
              ? res.data.message
              : 'プッシュ通知の配信停止に失敗しました';
          }
          // ローディング非表示設定, ボタン有効化設定
          setTimeout(() => {
            this.isLoadingStopBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'プッシュ通知の配信停止に失敗しました';
          // ローディング非表示設定, ボタン有効化設定
          setTimeout(() => {
            this.isLoadingStopBtn = false;
          }, 300);
        });
    },

    // 入力・選択: グループ選択
    onGroupSelect: function(selected) {
      this.groupId = selected;
    },

    updateLocalStorage: function() {
      if (this.groupType == 1 && this.groupId) {
        const key = 'default_group_' + this.messageInfo.serviceId + '_' + this.serviceType;
        window.localStorage.setItem(key, this.groupId);
      }
    },

    validate: function() {
      let isValid = true;
      let errors = {};
      if(!this.messageName){
        errors['push_name'] = 'プッシュ名を入力してください';
      }

      if(this.groupType == 1){
        if(!this.groupId){
          errors['group_name_select'] = 'グループ名を選択してください';
        }
      } else if(this.groupType == 2){
        if(!this.newGroupName){
          errors['message_group_name'] = 'グループ名を入力してください';
        }
      } else {
        errors['message_group'] = 'グループ設定を選択してください';
      }

      this.$refs.messageCartForm.validate(errors);

      if(Object.keys(errors).length > 0){
        this.showErrors(errors);
        isValid = false;
      }

      return isValid;
    },
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    saveMessage: function(completeUrl,hasArgument) {
      let params = new FormData();
      this.appendForm(params,'message_id',this.messageId);
      this.appendForm(params,'service_type',this.serviceType);
      this.appendForm(params,'message_name',this.messageName);
      this.appendForm(params,'click_url',this.message.clickUrl);
      this.appendForm(params,'image_url',this.message.iconUrl);
      this.appendForm(params,'large_image_url',this.message.largeImageUrl);
      this.appendForm(params,'badge_url',this.message.badgeUrl);
      if(this.groupType == 1){
        let convertedGroupId = this.groupId.slice(this.groupId.indexOf('_') + 1);
        this.appendForm(params,'group_id',convertedGroupId);
      } else if(this.groupType == 2){
        this.appendForm(params,'group_name',this.newGroupName);
      }
      this.appendForm(params,'cart_non_working_start_hours',this.message.cartNonWorkingStartHours);
      this.appendForm(params,'cart_non_working_end_hours',this.message.cartNonWorkingEndHours);
      this.appendForm(params,'utm_query',this.message.utmQuery);
      this.appendForm(params,'cart_work_hours_first',this.message.cartWorkHoursFirst);
      this.appendForm(params,'cart_title_first',this.message.cartTitleFirst);
      this.appendForm(params,'cart_message_first',this.message.cartMessageFirst);
      this.appendForm(params,'cart_work_hours_second',this.message.cartWorkHoursSecond);
      this.appendForm(params,'cart_title_second',this.message.cartTitleSecond);
      this.appendForm(params,'cart_message_second',this.message.cartMessageSecond);
      this.appendForm(params,'cart_work_hours_third',this.message.cartWorkHoursThird);
      this.appendForm(params,'cart_title_third',this.message.cartTitleThird);
      this.appendForm(params,'cart_message_third',this.message.cartMessageThird);
      this.appendForm(params,'deliver_type',this.messageInfo.deliverTypeValues.Immediate);

      params.append('icon_file',this.message.selectedIconFile);
      params.append('large_image_file',this.message.selectedLargeImageFile);
      params.append('badge_file',this.message.selectedBadgeFile);

      axios.post('/api/message/save',params)
        .then(res => {
          if(this.handleResponse(res)){
            let url = completeUrl;
            if(hasArgument){
              url += '?message_id=' + res.data.message_id;
            }
            location.href = url;
          } else {
            this.isError = true;
            this.errorMessage = (res && res.data && res.data.message)
              ? res.data.message
              : 'メッセージの保存に失敗しました';
          }

          setTimeout(() => {
            this.isLoadingConfirmBtn = false;
            this.isLoadingSaveBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'メッセージの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingConfirmBtn = false;
            this.isLoadingSaveBtn = false;
          }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // クリック: 完了モーダルを閉じる処理
    onCloseControlModal() {
      this.isCompleteMessage = false;
    },
    // クリック: 完了モーダルを閉じる処理
    onCancelControlModal() {
      this.isCompleteMessage = false;
      location.href = this.messageInfo.listUrl;
    },
  }
}
</script>
